<template>
  <BaseCard title="Barang">
    <Datatable
      :columns="[
        ...(source === 'stock'
          ? []
          : [{ id: 'order_code', name: 'Kode Faktur' }]),
        { id: 'product_code', name: 'Kode Barang' },
        { id: 'product_type', name: 'Tipe Barang' },
        { id: 'product_name', name: 'Nama Barang' },
        { id: 'stock_qty', name: 'Stock' },
        ...(source === 'stock'
          ? []
          : [{ id: 'ordered_qty', name: 'Jumlah Diterima' }]),
        { id: 'qty', name: 'Jumlah' },
        { id: 'action', name: 'Aksi' },
        { id: 'total_weight', name: 'Total Berat' },
        { id: 'point_value', name: 'PV' },
        { id: 'bonus_value', name: 'BV' },
      ]"
    >
      <template #tbody="{ classes }">
        <tr v-for="(item, index) in items" :key="item.id" :class="classes.tr">
          <td v-if="source === 'order_detail'" :class="classes.td">
            <SearchOrderInput
              v-model="items[index].orderCode"
              :disabled="!!item.id"
              :original-search="item.orderOriginalCode"
              :filter-order-params="{
                'filter[destination_office_id]': originOfficeId,
                'filter[order_status]': 'Selesai',
              }"
              @change="
                ({ order, closeModal }) =>
                  onChangeOrder({ index, order, closeModal })
              "
            />
          </td>
          <td :class="classes.td">
            <SearchStockInput
              v-if="source === 'stock' || item.orderId"
              ref="search_stock_input"
              :origin-warehouse="{ id: originWarehouseId }"
              :original-search="item.productOriginalCode"
              :type="source === 'order_detail' ? 'order-detail' : 'stock'"
              :order-id="item.orderId"
              v-model="items[index].productCode"
              @update:loading="onUpdateLoadingSearch"
              @change="
                ({ product, orderDetail, closeModal }) =>
                  onChangeStock({ index, product, orderDetail, closeModal })
              "
            />
          </td>
          <td :class="classes.td">
            <p v-if="item.id">{{ item.productType === 'free' ? 'Free' : 'Reguler' }}</p>
          </td>
          <td :class="classes.td">
            <p v-if="item.id">{{ item.productName }}</p>
          </td>
          <td :class="classes.td">
            <p v-if="item.id">{{ item.stockQty }}</p>
          </td>
          <td v-if="source === 'order_detail'" :class="classes.td">
            <p v-if="item.id">{{ item.orderedQty }}</p>
          </td>
          <td :class="classes.td">
            <input
              v-if="item.id"
              ref="item_qty"
              :disabled="disabled"
              type="number"
              class="w-full border-0 bg-transparent p-0 placeholder-gray-200 focus:border-0 focus:ring-0 sm:text-sm"
              placeholder="Jumlah"
              v-model="items[index].qty"
              @change="onChangeQty(index)"
            />
          </td>
          <td :class="classes.td">
            <button
              v-if="item.id"
              class="flex items-center text-red-600"
              @click="onRemove(index)"
            >
              <Icon icon="heroicons:x-mark" class="h-4 w-4" />
            </button>
          </td>
          <td :class="classes.td">
            <p v-if="item.id">{{ item.qty * item.weight }}</p>
          </td>
          <td :class="classes.td">
            <p v-if="item.id">{{ item.pointValue }}</p>
          </td>
          <td :class="classes.td">
            <p v-if="item.id">{{ item.bonusValue }}</p>
          </td>
        </tr>
      </template>

      <template #tfoot="{ classes }">
        <tfoot>
          <tr :class="[classes.tr, 'bg-gray-50']">
            <td
              :class="[classes.td, 'pb-0 text-right']"
              :colspan="source === 'stock' ? 7 : 8"
            >
              Total
            </td>
            <td :class="[classes.td, 'pb-0 text-right']">
              {{ summary.totalQty }}
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr :class="[classes.tr, 'bg-gray-50']">
            <td
              :class="[classes.td, 'pb-0 text-right']"
              :colspan="source === 'stock' ? 7 : 8"
            >
              Total Berat
            </td>
            <td :class="[classes.td, 'pb-0 text-right']">
              {{ summary.totalWeight }}
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr :class="[classes.tr, 'bg-gray-50']">
            <td
              :class="[classes.td, 'pb-0 text-right']"
              :colspan="source === 'stock' ? 7 : 8"
            >
              Total PV
            </td>
            <td :class="[classes.td, 'pb-0 text-right']">
              {{ summary.totalPointValue }}
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr :class="[classes.tr, 'bg-gray-50']">
            <td
              :class="[classes.td, 'text-right']"
              :colspan="source === 'stock' ? 7 : 8"
            >
              Total BV
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ summary.totalBonusValue }}
            </td>
            <td></td>
            <td></td>
          </tr>
        </tfoot>
      </template>
    </Datatable>

    <loading v-if="loading" />
  </BaseCard>
</template>

<script>
import { mapActions } from 'vuex';
import SearchStockInput from '../stock/search-stock-input.vue';
import { requestMixin } from '../../mixins/request/request';
import { sum } from '../../utils/array';
import SearchOrderInput from '../order/SearchOrderInput.vue';

export default {
  mixins: [requestMixin],
  props: {
    createReturAttributes: Object,
    originOfficeId: {
      type: String,
      required: true,
    },
    originWarehouseId: {
      type: String,
      required: true,
    },
    returId: String,
    disabled: Boolean,
    value: {
      type: Array,
      required: true,
    },
    source: {
      type: String,
      default: 'stock',
    },
  },
  emits: ['input', 'retur-created'],
  components: {
    SearchStockInput,
    SearchOrderInput,
  },
  data() {
    return {
      loadingSave: false,
      loadingSaveRetur: false,
      loadingSearch: false,
    };
  },
  computed: {
    items: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    loading() {
      return this.loadingSave || this.loadingSaveRetur || this.loadingSearch;
    },
    summary() {
      return {
        totalQty: sum(this.items, (item) => item.qty),
        totalWeight: sum(this.items, (item) => item.qty * item.weight),
        totalPointValue: sum(this.items, (item) => item.pointValue),
        totalBonusValue: sum(this.items, (item) => item.bonusValue),
      };
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async createItem(index, productId, orderId = null, orderDetailType) {
      if (!this.returId) {
        const [, err] = await this.createRetur();

        if (err) {
          return [null, err];
        }
      }

      const [res, err] = await this.postItem(productId, orderId, orderDetailType);

      if (!err) {
        const item = res.data;

        this.items[index].id = item.id;
        this.items[index].orderId = item.attributes.order_id;
        this.items[index].orderCode = item.attributes.order_origin_code;
        this.items[index].orderOriginalCode = item.attributes.order_origin_code;
        this.items[index].productType = item.attributes.product_type;
        this.items[index].productCode = item.attributes.product_code;
        this.items[index].productId = item.attributes.product_id;
        this.items[index].productOriginalCode = item.attributes.product_code;
        this.items[index].productName = item.attributes.product_name;
        this.items[index].stockQty = item.attributes.current_stock;
        this.items[index].qty = item.attributes.product_qty || null;
        this.items[index].originalQty = item.attributes.product_qty || null;
        this.items[index].orderedQty =
          item.attributes.product_ordered_qty || null;
        this.items[index].weight = item.attributes.product_weight || null;
        this.items[index].pointValue = item.attributes.product_point || null;
        this.items[index].bonusValue = item.attributes.product_bonus || null;

        this.$nextTick(() => {
          this.$refs.item_qty[index].focus();
        });
      }

      return [res, err];
    },
    async createRetur() {
      this.loadingSaveRetur = true;

      const [res, err] = await this.request('/api/v1/returs', {
        method: 'post',
        data: {
          data: {
            type: 'returs',
            attributes: {
              ...this.createReturAttributes,
            },
            relationships: {
              'origin-office': {
                data: {
                  type: 'offices',
                  id: this.originOfficeId,
                },
              },
            },
          },
        },
      });

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('retur-created', res);
      }

      this.loadingSaveRetur = false;

      return [res, err];
    },
    async onChangeStock({ index, product, orderDetail, closeModal }) {
      const [, err] = this.items[index].id
        ? await this.updateItem(index, product.id, orderDetail.type)
        : await this.createItem(index, product.id, this.items[index].orderId, orderDetail.type);

      if (!err && closeModal) {
        closeModal();
      } else {
        this.items[index].productCode = this.items[index].productOriginalCode;
      }
    },
    async onChangeOrder({ index, order, closeModal }) {
      this.items[index].orderId = order.attributes.order_id;
      this.items[index].orderCode = order.attributes.origin_code;
      this.items[index].orderOriginalCode = order.attributes.origin_code;

      if (closeModal) {
        closeModal();
      }
    },
    async onChangeQty(index) {
      this.loadingSave = true;

      const item = this.items[index];
      const qty = +item.qty;

      if (qty < 1) {
        this.items[index].qty = this.items[index].originalQty;
      } else {
        const [res, err] = await this.request(
          `/api/v1/retur-details/${item.id}`,
          {
            method: 'patch',
            data: {
              data: {
                type: 'retur-details',
                id: item.id,
                attributes: {
                  product_qty: +item.qty,
                },
              },
            },
          }
        );

        if (err) {
          this.items[index].qty = this.items[index].originalQty;

          this.createAlert({
            data: this.getRequestErrorMessage(err),
            status: 'error',
          });
        } else {
          this.items[index].originalQty = this.items[index].qty;
          this.items[index].stockQty = res.data.attributes.current_stock;

          if (index === this.items.length - 1) {
            this.pushEmptyItem();

            this.$nextTick(() => {
              this.$refs.search_stock_input[
                index + 1
              ].$refs.order_detail_code.focus();
            });
          }
        }
      }

      this.loadingSave = false;
    },
    async onRemove(index) {
      this.loadingSave = true;

      const item = this.items[index];

      const [, err] = await this.request(`/api/v1/retur-details/${item.id}`, {
        method: 'delete',
      });

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.items.splice(index, 1);

        if (!this.items.filter((item) => !item.id).length) {
          this.pushEmptyItem();
        }
      }

      this.loadingSave = false;
    },
    onUpdateLoadingSearch(value) {
      this.loadingSearch = value;
    },
    async patchItem(item, productId) {
      this.loadingSave = true;

      const [res, err] = await this.request(
        `/api/v1/retur-details/${item.id}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'retur-details',
              id: item.id,
              attributes: {
                product_qty: 0,
              },
              relationships: {
                product: {
                  data: {
                    type: 'products',
                    id: productId,
                  },
                },
              },
            },
          },
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      }

      this.loadingSave = false;

      return [res, err];
    },
    async postItem(productId, orderId = null, orderDetailType) {
      this.loadingSave = true;

      const [res, err] = await this.request('/api/v1/retur-details', {
        method: 'post',
        data: {
          data: {
            type: 'retur-details',
            attributes: {
              product_qty: 0,
              product_type: orderDetailType === 'order-detail-bonuses' ? 'free' : 'reguler'
            },
            relationships: {
              retur: {
                data: {
                  type: 'returs',
                  id: this.returId,
                },
              },
              product: {
                data: {
                  type: 'products',
                  id: productId,
                },
              },
              ...(!orderId
                ? {}
                : {
                    order: {
                      data: {
                        type: 'orders',
                        id: orderId,
                      },
                    },
                  }),
            },
          },
        },
      });

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      }

      this.loadingSave = false;

      return [res, err];
    },
    pushEmptyItem() {
      this.items.push({
        id: null,
        orderId: null,
        orderCode: null,
        orderOriginalCode: null,
        productId: null,
        productType: null,
        productCode: null,
        productOriginalCode: null,
        productName: null,
        stockQty: null,
        qty: null,
        originalQty: null,
        orderedQty: null,
        weight: null,
        pointValue: null,
        bonusValue: null,
      });
    },
    async updateItem(index, productId) {
      const item = this.items[index];

      const [res, err] = await this.patchItem(item, productId);

      if (!err) {
        const newItem = res.data;

        this.items[index].orderId = newItem.attributes.order_id;
        this.items[index].orderCode = newItem.attributes.order_origin_code;
        this.items[index].orderOriginalCode =
          newItem.attributes.order_origin_code;
        this.items[index].productCode = newItem.attributes.product_code;
        this.items[index].productType = newItem.attributes.product_type;
        this.items[index].productId = newItem.attributes.product_id;
        this.items[index].productOriginalCode = newItem.attributes.product_code;
        this.items[index].productName = newItem.attributes.product_name;
        this.items[index].stockQty = newItem.attributes.current_stock;
        this.items[index].qty = newItem.attributes.product_qty || null;
        this.items[index].originalQty = newItem.attributes.product_qty || null;
        this.items[index].orderedQty =
          newItem.attributes.product_ordered_qty || null;
        this.items[index].weight = newItem.attributes.product_weight || null;
        this.items[index].pointValue = newItem.attributes.product_point || null;
        this.items[index].bonusValue = newItem.attributes.product_bonus || null;

        this.$nextTick(() => {
          this.$refs.item_qty[index].focus();
        });
      }

      return [res, err];
    },
  },
};
</script>
